import type { BoardSummary } from "@mn/shared";
import { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { useSession } from "@/app/session";
import { Shell } from "@/components/Shell";
import { Alert, Spinner } from "@/components/ui";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { BoardTile } from "./board/BoardTile";

type HomeData = { kind: "root"; rootBoardId: string } | { kind: "shared"; boards: BoardSummary[] };

export default function Home() {
  const t = useT();
  const { me } = useSession();
  const [data, setData] = useState<HomeData | null>(null);
  useEffect(() => {
    api<HomeData>("/api/home").then(setData);
  }, []);
  if (!data)
    return (
      <Shell>
        <div className="flex items-center gap-2 p-8 text-muted">
          <Spinner /> {t.loading}
        </div>
      </Shell>
    );
  if (data.kind === "root") return <Navigate to={`/b/${data.rootBoardId}`} replace />;
  return (
    <Shell>
      <div className="mx-auto max-w-6xl px-6 py-8">
        <h1 className="display mb-6 text-4xl">.{t.sharedWithMe}</h1>
        {data.boards.length === 0 ? (
          <Alert>{me?.staffRole ? t.nothingShared : t.noAccess}</Alert>
        ) : (
          <div className="flex flex-wrap gap-6">
            {data.boards.map((b) => (
              <BoardTile key={b.id} board={b} />
            ))}
          </div>
        )}
      </div>
    </Shell>
  );
}
